import { PASSWORD_MIN_LENGTH } from '@teentack/shared';
import { scorePassword } from './password-strength';

export function PasswordMeter({ value }: { value: string }) {
  if (!value) return null;

  const { score, label, tone } = scorePassword(value);
  const remaining = PASSWORD_MIN_LENGTH - value.length;

  return (
    <div className="mt-2">
      <div className="flex gap-1.5" aria-hidden="true">
        {[1, 2, 3, 4].map((step) => (
          <span
            key={step}
            className={`h-1 flex-1 rounded-full transition-colors duration-300 ${
              step <= score ? tone : 'bg-slate-200'
            }`}
          />
        ))}
      </div>
      <p className="mt-1.5 text-xs text-slate-500" aria-live="polite">
        <span className="font-semibold text-ink">{label}</span>
        {remaining > 0 && ` — ${remaining} more character${remaining === 1 ? '' : 's'} to go`}
      </p>
    </div>
  );
}
